module.exports = __webpack_public_path__ + "80c635d8b0dcf1e44a0f8a7f0cc86ad7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/drillseeeding.jpg
// module id = 114
// module chunks = 1